import { render, staticRenderFns } from "./CreateOptoutModal.vue?vue&type=template&id=50f3a248&scoped=true"
import script from "./CreateOptoutModal.vue?vue&type=script&lang=js"
export * from "./CreateOptoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f3a248",
  null
  
)

export default component.exports